import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=b04be184&scoped=true&"
import script from "./MainLayout.vue?vue&type=script&setup=true&lang=js&"
export * from "./MainLayout.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=b04be184&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04be184",
  null
  
)

export default component.exports